export default {
  rollover: {
    title: '롤오버',
    detailsTitle: '롤오버 상세',
    all: '전체',
    allStats: '전체 상태',
    select: '선택',
    rolloverType: '롤오버 유형',
    amount: '금액',
    source: '출처',
    wallet: '지갑',
    current: '현재',
    wagered: '배팅 완료',
    required: '필요',
    progress: '진행률',
    loading: '로딩 중...',
    noData: '데이터 없음',
    noMoreData: '더 이상 데이터 없음',
    state: '상태',
    type: '유형',
    createdOn: '생성일',
    wageringRequirement: '배팅 요건',
    currency: '통화',
    wagerRequired: '필요 배팅액',
    wagerCompleted: '완료 배팅액',
    cash: '캐시',
    bonus: '보너스',
  },
};
